export const updateSubscriptionTime = 5000; // ms
export const updateSubscriptionRepeatCount = 3;
export const cancelSubscriptionRepeatCount = 4;
export const activateSubscriptionRepeatCount = 4;
export const updateSubscriptionDebounceTime = 2000; // ms;
